import { render } from "./SmSonginfo.vue?vue&type=template&id=58bbbde2"
import script from "./SmSonginfo.vue?vue&type=script&lang=js"
export * from "./SmSonginfo.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__